import React, { useEffect, useState, useRef } from 'react';
import logoMettePrim from '../../../assets/logoMettePrim.gif'
import logoMTE from '../../../assets/LogoMTE.png'
import projectAiPlatform from '../../../assets/project-ai-platform.jpg'
import { Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import './home.css';
import './public-theme.css';
import AuthCorner from './AuthCorner';

const WHATSAPP_NUMBER = '47984422902';
const WHATSAPP_DEFAULT = 'https://wa.me/47984422902?text=Bom%20dia!%0A%20%20%0A*(Mensagem%20automatizada%20atrav%C3%A9s%20do%20site%20Mette)*';

const SOCIAL_LINKS = [
  { label: 'LinkedIn', handle: '/in/fernandomette →', href: 'https://www.linkedin.com/in/fernandomette/' },
  { label: 'GitHub', handle: '@fernandomette →', href: 'https://github.com/fernandomette' },
  { label: 'Instagram', handle: '@fernando.mette →', href: 'https://www.instagram.com/fernando.mette/' },
  { label: 'YouTube', handle: '@MettePrim →', href: 'https://www.youtube.com/@MettePrim' },
  { label: 'WhatsApp', handle: 'Enviar mensagem →', href: WHATSAPP_DEFAULT },
];

const NAV_ITEMS = [
  { href: '#inicio', short: 'Início', full: 'Início' },
  { href: '#sobre', short: 'Sobre', full: 'Sobre' },
  { href: '#stack', short: 'Stack', full: 'Stack' },
  { href: '#experiencia', short: 'Exp.', full: 'Experiência' },
  { href: '#projetos', short: 'Projetos', full: 'Projetos' },
  { href: '#social', short: 'Redes', full: 'Redes Sociais' },
  { href: '#contato', short: 'Contato', full: 'Entre em contato' },
];

const TECH_BADGES = [
  'JavaScript',
  'TypeScript',
  'Node.js',
  'React',
  'React Native',
  'AWS',
  'SQL',
  'Serverless',
];

const STACK_ITEMS = [
  { tag: 'FRONTEND', name: 'React & Next.js' },
  { tag: 'BACKEND', name: 'Node.js & TS' },
  { tag: 'MOBILE', name: 'React Native' },
  { tag: 'CLOUD', name: 'AWS Services' },
  { tag: 'DATABASE', name: 'SQL & NoSQL' },
  { tag: 'INTELLIGENCE', name: 'Applied AI' },
];

function handleNavClick(event, href) {
  event.preventDefault();
  const el = document.querySelector(href);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function HomePage() {
  const [waMessage, setWaMessage] = useState('');
  const waHref = waMessage.trim()
    ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(waMessage)}`
    : WHATSAPP_DEFAULT;

  const taglineBase = 'Desenvolvendo soluções escaláveis, modernas e inteligentes ';
  const taglineAccent = 'na nuvem.';
  const taglineFull = taglineBase + taglineAccent;
  const [typed, setTyped] = useState(0);

  useEffect(() => {
    if (typed >= taglineFull.length) return;
    const timer = setTimeout(() => setTyped((n) => n + 1), 42);
    return () => clearTimeout(timer);
  }, [typed, taglineFull.length]);

  return (
    <FnPageLogoDown>
      <div className="mette-public-theme min-h-screen shrink-0 bg-background text-foreground font-body">
        {/* Fundo fixo: cobre toda a viewport, inclusive atrás do rodapé de logos
            adicionado pelo FnPageLogoDown (que é irmão deste bloco, não filho). */}
        <div aria-hidden="true" className="fixed inset-0 -z-10 bg-background" />

        {/* Nav fixo */}
        <nav className="fixed top-0 left-0 right-0 z-50 flex justify-center py-3 sm:py-6 px-3 pr-16 sm:pr-20">
          <div className="flex items-center gap-2 sm:gap-6 px-3 sm:px-6 py-2 sm:py-2.5 rounded-full bg-background/60 backdrop-blur-md border border-border/50 shadow-2xl max-w-full overflow-x-auto no-scrollbar">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="no-underline text-[10px] sm:text-xs font-mono tracking-widest uppercase hover:text-accent transition-colors text-muted-foreground whitespace-nowrap shrink-0"
              >
                <span className="sm:hidden">{item.short}</span>
                <span className="hidden sm:inline">{item.full}</span>
              </a>
            ))}
          </div>
        </nav>

        <AuthCorner />

        {/* Hero */}
        <section
          id="inicio"
          className="relative min-h-screen flex flex-col items-center justify-center px-6 overflow-hidden"
        >
          <div className="absolute inset-0 z-0">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/10 rounded-full blur-[120px]" />
            <div
              className="absolute inset-0 opacity-[0.07]"
              style={{
                backgroundImage:
                  'linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)',
                backgroundSize: '56px 56px',
                maskImage:
                  'radial-gradient(ellipse at center, black 40%, transparent 75%)',
              }}
            />
          </div>

          <svg
            aria-hidden="true"
            className="hidden lg:block absolute top-[18%] left-[8%] w-40 h-40 text-accent/20 animate-mette-fade-up"
            viewBox="0 0 100 100"
            fill="none"
            stroke="currentColor"
            strokeWidth="0.6"
            style={{ animationDelay: '200ms' }}
          >
            <path d="M20 30 L50 15 L80 30 L80 70 L50 85 L20 70 Z" />
            <path d="M20 30 L50 45 L80 30" />
            <path d="M50 45 L50 85" />
          </svg>
          <svg
            aria-hidden="true"
            className="hidden lg:block absolute bottom-[22%] right-[9%] w-32 h-32 text-accent/20 animate-mette-fade-up"
            viewBox="0 0 100 100"
            fill="none"
            stroke="currentColor"
            strokeWidth="0.6"
            style={{ animationDelay: '400ms' }}
          >
            <path d="M20 30 L50 15 L80 30 L80 70 L50 85 L20 70 Z" />
            <path d="M20 30 L50 45 L80 30" />
            <path d="M50 45 L50 85" />
          </svg>

          {/* Card de código */}
          <div
            className="hidden 2xl:block absolute left-[4%] top-1/2 -translate-y-1/2 w-[340px] rounded-xl border border-border/70 bg-card/80 backdrop-blur-md shadow-2xl animate-mette-fade-up overflow-hidden"
            style={{ animationDelay: '600ms' }}
          >
            <div className="flex items-center gap-1.5 px-4 py-2.5 border-b border-border/60 bg-white/[0.02]">
              <span className="size-2.5 rounded-full bg-red-500/70" />
              <span className="size-2.5 rounded-full bg-yellow-500/70" />
              <span className="size-2.5 rounded-full bg-green-500/70" />
              <span className="ml-3 font-mono text-[10px] text-muted-foreground uppercase tracking-widest">
                buildSolution.ts
              </span>
            </div>
            <pre className="px-4 py-4 text-[11px] leading-relaxed font-mono text-muted-foreground overflow-hidden">
{`async function buildSolution() {
  const ideas = await brainstorm();
  const code  = develop(ideas);
  const tests = await runTests(code);
  if (tests.passed) {
    await deploy(code);
    return 'Delivered with quality.';
  }
  return improve(code, tests);
}`}
            </pre>
          </div>

          {/* Diagrama estilo AWS */}
          <div
            className="hidden 2xl:block absolute right-[4%] top-1/2 -translate-y-1/2 w-[320px] animate-mette-fade-up"
            style={{ animationDelay: '700ms' }}
          >
            <svg viewBox="0 0 320 280" className="w-full h-auto" fill="none">
              <g
                stroke="var(--mette-accent)"
                strokeOpacity="0.4"
                strokeWidth="1"
                strokeDasharray="3 4"
              >
                <path d="M160 40 L160 90" />
                <path d="M160 90 L70 150" />
                <path d="M160 90 L160 150" />
                <path d="M160 90 L250 150" />
                <path d="M70 150 L70 220" />
                <path d="M160 150 L160 220" />
                <path d="M250 150 L250 220" />
              </g>
              {[
                { x: 160, y: 40, label: 'AWS', strong: true },
                { x: 160, y: 90, label: 'API Gateway' },
                { x: 70, y: 150, label: 'CloudFront' },
                { x: 160, y: 150, label: 'Lambda' },
                { x: 250, y: 150, label: 'S3' },
                { x: 70, y: 220, label: 'RDS' },
                { x: 160, y: 220, label: 'Cognito' },
                { x: 250, y: 220, label: 'DynamoDB' },
              ].map((n) => (
                <g key={n.label}>
                  <rect
                    x={n.x - 42}
                    y={n.y - 14}
                    width="84"
                    height="28"
                    rx="6"
                    fill="var(--mette-card)"
                    stroke="var(--mette-accent)"
                    strokeOpacity={n.strong ? '0.9' : '0.4'}
                  />
                  <text
                    x={n.x}
                    y={n.y + 4}
                    textAnchor="middle"
                    fontFamily="ui-monospace, monospace"
                    fontSize="10"
                    fill="var(--mette-foreground)"
                    opacity={n.strong ? '1' : '0.8'}
                  >
                    {n.label}
                  </text>
                </g>
              ))}
            </svg>
          </div>

          {/* Conteúdo central */}
          <div className="relative z-10 text-center max-w-4xl">
            <span
              className="font-mono text-accent text-sm tracking-[0.3em] uppercase mb-6 block animate-mette-fade-up"
              style={{ animationDelay: '100ms' }}
            >
              Full Stack Developer
            </span>
            <h1
              className="font-display text-6xl md:text-9xl font-extrabold tracking-tighter mb-8 animate-mette-fade-up"
              style={{ animationDelay: '300ms' }}
            >
              Fernando Mette
            </h1>
            <p
              className="text-xl md:text-2xl text-muted-foreground text-balance max-w-2xl mx-auto leading-relaxed animate-mette-fade-up"
              style={{ animationDelay: '500ms' }}
            >
              <span>{taglineBase.slice(0, Math.min(typed, taglineBase.length))}</span>
              {typed > taglineBase.length && (
                <span className="text-accent">
                  {taglineAccent.slice(0, typed - taglineBase.length)}
                </span>
              )}
              {typed < taglineFull.length && (
                <span className="inline-block w-[2px] h-[1em] bg-accent align-middle ml-0.5 animate-pulse" />
              )}
            </p>

            <div
              className="mt-10 flex flex-wrap items-center justify-center gap-2 animate-mette-fade-up"
              style={{ animationDelay: '800ms' }}
            >
              {TECH_BADGES.map((t) => (
                <span
                  key={t}
                  className="px-3 py-1.5 rounded-full border border-border/70 bg-white/[0.02] font-mono text-[10px] uppercase tracking-widest text-muted-foreground hover:text-accent hover:border-accent/50 transition-colors"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce opacity-20">
            <div className="w-px h-12 bg-foreground" />
          </div>
        </section>

        <main className="max-w-4xl mx-auto px-6 py-24 space-y-40">
          {/* Sobre */}
          <section id="sobre" className="grid md:grid-cols-[1fr_2fr] gap-8 md:gap-12 items-start scroll-mt-28">
            <div className="md:sticky md:top-32">
              <span className="font-mono text-accent/60 text-xs">01 //</span>
              <h2 className="text-2xl font-semibold mt-2">Sobre</h2>
            </div>
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>
                Desenvolvedor Full Stack especializado em JavaScript e TypeScript, com experiência no desenvolvimento de aplicações web utilizando Node.js, React, React Native, SQL e AWS.
              </p>
              <p>
                Atuo em todo o ciclo de desenvolvimento, desde arquitetura e implementação até deploy, monitoramento e sustentação de ambientes produtivos. Tenho experiência com APIs, integrações entre sistemas, banco de dados e aplicações escaláveis.
              </p>
              <p>
                Também trabalho com infraestrutura em nuvem, observabilidade e investigação de incidentes, utilizando ferramentas de IA como Cursor e integrações via MCP para acelerar diagnósticos e aumentar a produtividade.
              </p>
            </div>
          </section>

          {/* Stack */}
          <section id="stack" className="grid md:grid-cols-[1fr_2fr] gap-8 md:gap-12 items-start scroll-mt-28">
            <div className="md:sticky md:top-32">
              <span className="font-mono text-accent/60 text-xs">02 //</span>
              <h2 className="text-2xl font-semibold mt-2">Stack</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {STACK_ITEMS.map((s) => (
                <div
                  key={s.tag}
                  className="p-4 border border-border bg-white/[0.02] rounded-lg"
                >
                  <div className="text-xs font-mono text-accent mb-2">{s.tag}</div>
                  <div className="font-semibold">{s.name}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Experiência */}
          <section id="experiencia" className="grid md:grid-cols-[1fr_2fr] gap-8 md:gap-12 items-start scroll-mt-28">
            <div className="md:sticky md:top-32">
              <span className="font-mono text-accent/60 text-xs">03 //</span>
              <h2 className="text-2xl font-semibold mt-2">Experiência</h2>
            </div>
            <div className="space-y-12">
              <div className="relative pl-8 border-l border-border">
                <div className="absolute -left-1.5 top-1.5 size-3 rounded-full bg-accent" />
                <div className="mb-1 font-mono text-sm text-accent">
                  2022 — PRESENTE
                </div>
                <h3 className="text-xl font-bold">Fastbuilt</h3>
                <p className="text-muted-foreground mt-2">
                  Desenvolvimento Full Stack em plataforma para gestão de obras.
                  Foco em performance React, integrações via Node.js e
                  arquitetura na AWS.
                </p>
              </div>
              <div className="group relative pl-8 border-l border-border">
                <div className="absolute -left-1.5 top-1.5 size-3 rounded-full bg-border group-hover:bg-accent transition-colors" />
                <div className="mb-1 font-mono text-sm text-muted-foreground">
                  2025 — 2026
                </div>
                <h3 className="text-xl font-bold">Projetos Independentes</h3>
                <p className="text-muted-foreground mt-2">
                  Desenvolvimento de MVPs, aplicações mobile em React Native e Type Script,
                  consultoria técnica em arquitetura serverless na AWS.
                </p>
              </div>
            </div>
          </section>

          {/* Projetos */}
          <section id="projetos" className="grid md:grid-cols-[1fr_2fr] gap-8 md:gap-12 items-start scroll-mt-28">
            <div className="md:sticky md:top-32">
              <span className="font-mono text-accent/60 text-xs">04 //</span>
              <h2 className="text-2xl font-semibold mt-2">Projetos</h2>
            </div>
            <div className="grid gap-8">
              <article className="group overflow-hidden rounded-2xl border border-border bg-card hover:border-accent/50 transition-all duration-500">
                <img
                  src={projectAiPlatform}
                  alt="Plataforma de IA — dashboard técnico"
                  width={1200}
                  height={800}
                  loading="lazy"
                  className="w-full h-auto"
                />
                <div className="p-6">
                  <h4 className="text-lg font-bold">IA Platform HubSpot</h4>
                  <p className="text-muted-foreground text-sm mt-2">
                    Plataforma de atendimento inteligente com IA, integrada ao HubSpot, utilizando documentação em MDX como base de conhecimento para fornecer respostas contextualizadas e automatizar o suporte.
                  </p>
                </div>
              </article>
              <a
                href="https://github.com/fernandomette"
                target="_blank"
                rel="noreferrer"
                className="no-underline text-foreground flex items-center justify-between p-6 rounded-xl border border-border hover:bg-white/5 transition-colors"
              >
                <span className="font-bold">Repositórios no GitHub</span>
                <span className="font-mono text-xs text-muted-foreground">
                  @fernandomette →
                </span>
              </a>
            </div>
          </section>

          {/* Redes Sociais & Contato */}
          <section
            id="social"
            className="grid md:grid-cols-[1fr_2fr] gap-8 md:gap-12 items-start scroll-mt-28"
          >
            <div className="md:sticky md:top-32">
              <span className="font-mono text-accent/60 text-xs">05 //</span>
              <h2 className="text-2xl font-semibold mt-2">Redes Sociais</h2>
            </div>
            <div className="flex flex-col gap-4">
              {SOCIAL_LINKS.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  target="_blank"
                  rel="noreferrer"
                  className="no-underline text-foreground flex items-center justify-between p-6 rounded-xl border border-border hover:bg-white/5 transition-colors"
                >
                  <span className="font-bold">{l.label}</span>
                  <span className="font-mono text-xs text-muted-foreground">
                    {l.handle}
                  </span>
                </a>
              ))}

              <div
                id="contato"
                className="mt-8 pt-8 border-t border-border scroll-mt-32"
              >
                <h3 className="text-4xl font-display font-bold mb-4">
                  Vamos conversar?
                </h3>
                <a
                  href="mailto:fernando@mette.com.br"
                  className="no-underline text-accent text-xl font-mono hover:underline underline-offset-8"
                >
                  fernando@mette.com.br
                </a>

                <div className="mt-8 p-6 rounded-xl border border-border bg-white/[0.02]">
                  <label
                    htmlFor="wa-message"
                    className="block font-mono text-xs uppercase tracking-widest text-muted-foreground mb-3"
                  >
                    Enviar mensagem no WhatsApp
                  </label>
                  <textarea
                    id="wa-message"
                    value={waMessage}
                    onChange={(e) => setWaMessage(e.target.value)}
                    placeholder="Escreva sua mensagem..."
                    rows={4}
                    className="w-full resize-none rounded-lg bg-background border border-border p-4 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-accent transition-colors"
                  />
                  <a
                    href={waHref}
                    target="_blank"
                    rel="noreferrer"
                    className="no-underline mt-4 inline-flex items-center justify-center px-6 py-3 rounded-lg bg-accent text-accent-foreground font-mono text-xs uppercase tracking-widest hover:opacity-90 transition-opacity"
                  >
                    Enviar pelo WhatsApp →
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </FnPageLogoDown>
  );
}

export function FnPageLogoDown({ children }) {
  const history = useHistory();
  const [clickCountMTE, setClickCountMTE] = useState(0);
  const timeoutRefMTE = useRef(null);
  const [clickCountHome, setClickCountHome] = useState(0);
  const timeoutRefHome = useRef(null);

  const handleLogoClickMTE = () => {
    if (timeoutRefMTE.current) {
      clearTimeout(timeoutRefMTE.current);
    }

    const newCount = clickCountMTE + 1;
    setClickCountMTE(newCount);

    if (newCount >= 3) {
      history.push('/login');
      setClickCountMTE(0);
    } else {
      timeoutRefMTE.current = setTimeout(() => {
        setClickCountMTE(0);
        timeoutRefMTE.current = null;
      }, 2000);
    }
  };

  const handleLogoClickHome = () => {
    if (timeoutRefHome.current) {
      clearTimeout(timeoutRefHome.current);
    }

    const newCount = clickCountHome + 1;
    setClickCountHome(newCount);

    if (newCount >= 3) {
      history.push('/home');
      setClickCountHome(0);
    } else {
      timeoutRefHome.current = setTimeout(() => {
        setClickCountHome(0);
        timeoutRefHome.current = null;
      }, 2000);
    }
  };

  return (
    <Box className="sub-body-home-page">
      {children}
      <Box className="home-page-logos">
        <img
          style={{ width: "100px", margin: 10 }}
          src={logoMettePrim}
          alt="Logo Mette"
          onClick={handleLogoClickHome}
        />
        <img
          style={{ width: "100px", margin: 10 }}
          src={logoMTE}
          alt="Logo MTE"
          onClick={handleLogoClickMTE}
        />
      </Box>

    </Box>
  );
}

export default HomePage;
